import { httpClient } from '../http/httpClient'

export type ContextParams = {
  type: 'S' | 'C' | 'B' | 'Y' | 'V'
  stateId?: number
  typeVehicle?: 'C' | 'M' | 'TM'
  brandId?: number
  year?: number
}

export type ContextItem = {
  id: number
  text: string
  back: string | null
}

export async function getContext(
  params: ContextParams,
): Promise<ContextItem[]> {
  const { data } = await httpClient
    .get<ContextItem[]>('/salvcar/context', {
      params,
    })
    .catch((error) => {
      throw error.response?.data ?? error
    })

  return data
}
